import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PollstarHeadingComponent} from "@app/shared/partials/pollstar-heading/pollstar-heading.component";


@NgModule({
  declarations: [PollstarHeadingComponent],
  imports: [
    CommonModule,
  ],
  exports: [PollstarHeadingComponent]
})
export class PollstarHeadingModule { }
